import { $, T } from "../../common/drupal/drupal";

import Swiper, { Navigation, Pagination, Autoplay } from "swiper";

/**
 * Class exemple de gestion du pragraph carousel
 */
class CarouselParagraph {

    /**
     * init
     */
    init() {
        const swipers = [];
        Swiper.use([Navigation, Pagination, Autoplay])
        Array.from($('.ParagraphCarousel-carousel')).forEach((paragraph, i) => {
            let slideLength = $(paragraph).find('.swiper-slide').length;
            let loopOption = false;
            let pagination = {};
            let navigation = {};
            let $navigationButtons = $('.ParagraphCarousel-button-next, .ParagraphCarousel-button-prev');
            $navigationButtons.hide();

            if (slideLength > 1) {
                pagination = {
                    el: $(paragraph).find('.ParagraphCarousel-pagination')[0],
                };
                navigation = {
                    nextEl: $(paragraph).find('.ParagraphCarousel-button-next')[0],
                    prevEl: $(paragraph).find('.ParagraphCarousel-button-prev')[0],
                };
                loopOption = true;
                $navigationButtons.show();
            }
            
            swipers[i] = new Swiper(paragraph, {
                spaceBetween: 60,
                slidesPerView: 'auto',
                loop: loopOption,
                autoHeight: true,
                autoplay: {
                    delay: 5000,
                },
                // If we need pagination
                pagination: pagination,

                // Navigation arrows
                navigation: navigation
            });
        })

    }

    /**
     * Attach.
     * @param context
     */
    attach(context) {
        if (T.contextIsRoot(context) && $('.ParagraphCarousel').length > 0) {
            this.init();
        }
    }
}

export let carouselParagraph = new CarouselParagraph();
